import { render, staticRenderFns } from "./CrudSelectiveProcess.vue?vue&type=template&id=f082c4c6&scoped=true&"
import script from "./CrudSelectiveProcess.vue?vue&type=script&lang=js&"
export * from "./CrudSelectiveProcess.vue?vue&type=script&lang=js&"
import style0 from "./CrudSelectiveProcess.vue?vue&type=style&index=0&id=f082c4c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f082c4c6",
  null
  
)

export default component.exports